import * as React from 'react';
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import Nav from "./nav";
import Footer from "../admin/footer";
import axios from 'axios';
import { useState, useEffect } from "react";


const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));


export default function Dashboard() {

  const [list,setList]=useState([])
  const [listold,setListold]=useState([])
  const [listoldStatus,setListoldStatus]=useState(false)
  const [user,setUser]=useState()
  const [days,setDays]=useState("");
  const [d1,setD1]=useState(null);
  const [d2,setD2]=useState(null);

  const [selected,setSelected]=useState(null)
  const [agentList,setAgentList]=useState([])
  const [teamList,setTeamList]=useState([])
  const [selected_t,setSelected_t]=useState(null)
  const [selected_type,setSelected_type]=useState(null)

  const [section_b,setSection_b]=useState(false)
  

  const [selected_website,setSelected_website]=useState(null)
  const [WebsiteList,setWebsiteList]=useState([])
  const [TypeList,setTypeList]=useState([])
  const [f1,setf1]=useState("")
  const [f2,setf2]=useState("")
  const [f3,setf3]=useState("")
  const [f4,setf4]=useState("")


  useEffect(() => {
    getStatus();
    const a=localStorage.getItem("Admin");
    if(a==null)
    {
      window.location.replace("/login")
    }else{
      
      setUser(a)
      
      all_agent_get()
      TeamList()
      webList()
      Get_type_list()

      const access=JSON.parse(localStorage.getItem("Access"))
      if(access[0].a8!=true){
       window.location.replace("/admin_main")
      }else{
        setSection_b(access[0].a9)
      }

      
    }
  
  
  }, []);





  const all_agent_get = async (typ,id)=> {
    const data = new FormData();
   
            axios({
              method: 'post',
              url: '/api_lock/admin/all_agent.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                    setAgentList(s.data)
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  const Get_type_list = async ()=> {
    const data = new FormData();
     
            axios({
              method: 'post',
              url: '/api_lock/web/listtype.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                setTypeList(s.data)

              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };


  const webList = async ()=> {
    const data = new FormData();
     
            axios({
              method: 'post',
              url: '/api_lock/web/list.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                setWebsiteList(s.data)

              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

          const getresponseCount = () => {
            return list.filter(item => item.manager_response == 0 ).length;
          }

          
  const getfilter_dail = () => {
    
    const a=list;
    if(listoldStatus)
    {
      const newArray = a.filter(item => item.manager_response >0)

      setList(newArray)
      console.log("array s ",newArray)
    }else{
      setListold(a)
      setListoldStatus(true)

      const newArray = a.filter(item => item.manager_response >0 );

      setList(newArray)

      console.log("array ",newArray)

    }  
  }
  const getfilter_none_dial = () => {
    
    const a=list;
    if(listoldStatus)
    {
      const newArray = a.filter(item => item.manager_response==0);

      setList(newArray)
      console.log("array s ",newArray)
    }else{
      setListold(a)
      setListoldStatus(true)

      const newArray = a.filter(item => item.manager_response==0);

      setList(newArray)

      console.log("array ",newArray)

    }  
  }

  const getInq = async ()=> {
    const data = new FormData();
    
    data.append('d1',d1);
    data.append('d2',d2);
            axios({
              method: 'post',
              url: '/api_lock/admin/date_to_date.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                setList(s.data)
                console.log(s.data)
               
         
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  // Function to count the items based on status
  const getStatusCount = status => {
    return list.filter(item => item.agent_status === status).length;
  }

  const getfilter = status => {
    const a=list;
    setf1(status)
    if(listoldStatus)
    {
      const newArray = a.filter(item => item.agent_status === status);
      setList(newArray)
      console.log("array s ",newArray)
    }else{
      
      setListold(a)
      setListoldStatus(true)

      const newArray = a.filter(item => item.agent_status === status);
      setList(newArray)


      console.log("array ",newArray)

    }

  
    
  }
  const getfilter_Team = status => {
    const a=list;
    if(listoldStatus)
    {
      const newArray = a.filter(item => item.team_id === status);
      setList(newArray)
      console.log("array s ",newArray)
    }else{
      setListold(a)
      setListoldStatus(true)
      const newArray = a.filter(item => item.team_id === status);
      setList(newArray)
      console.log("array ",newArray)

    }

  
    
  }

  const getfilter_type = status => {
    const a=list;
    setf2(status)
    if(listoldStatus)
    {
      const newArray = a.filter(item => item.sender_type === status);
      setList(newArray)
      console.log("array s ",newArray)
    }else{
      setListold(a)
      setListoldStatus(true)
      const newArray = a.filter(item => item.sender_type === status);
      setList(newArray)
      console.log("array ",newArray)
    }
  }

  const getfilter_website = status => {
    const a=list;
    setf3(status)
    if(listoldStatus)
    {
      const newArray = a.filter(item => item.web === status);
      setList(newArray)
      console.log("array s ",newArray)
    }else{
      setListold(a)
      setListoldStatus(true)
      const newArray = a.filter(item => item.web === status);
      setList(newArray)
      console.log("array ",newArray)
    }
    
  }

  const getfilter_Agent = (status,name) => {
    setf4(name)
    const a=list;
    if(listoldStatus)
    {
      const newArray = a.filter(item => item.agent_id === status);
      setList(newArray)
      console.log("array s ",newArray)
    }else{
      setListold(a)
      setListoldStatus(true)
      const newArray = a.filter(item => item.agent_id === status);
      setList(newArray)
      console.log("array ",newArray)

    }

  
    
  }

  const getfilter_Type_source = (status) => {
    
    const a=list;
    if(listoldStatus)
    {
      const newArray = a.filter(item => item.type === status);
      setList(newArray)
      console.log("array s ",newArray)
    }else{
      setListold(a)
      setListoldStatus(true)
      const newArray = a.filter(item => item.type === status);
      setList(newArray)
      console.log("array ",newArray)

    }

  
    
  }

  const getTypeCount = status => {
    return list.filter(item => item.sender_type === status).length;
  }
  const TeamList = async ()=> {
    const data = new FormData();
        data.append('status',"login");
            axios({
              method: 'post',
              url: '/api_lock/team/all_view.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
                setTeamList(s.data)
                })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

  const resetAll = () => {
    const a=listold;
    setList(a)
    setListoldStatus(false)
    setSelected()
    setSelected_website()
    setf1("")
    setf2("")
    setf3("")
    setf4("")
  }

  const [status_list,setStatusList]=useState([])
  const getStatus = async ()=> {
    const data = new FormData();
    data.append('inquiry_id','');
 
            axios({
              method: 'post',
              url: '/api_lock/status/list.php',
              data: data,
              headers: {'Content-Type': 'multipart/form-data'},
            })
              .then(s => {
               

                 console.log(s.data)
                 setStatusList(s.data)
               
                
              
         
              })
              .catch(s => {
                console.log('here catch =>>', s);
              });
          };

                     // Function to get names by value
                     const getNamesByValue = (array, value) => {
                      return array
                        .filter(item => item.value === value)
                        .map(item => item.name);
                    };



  return (
  <>

  <Nav />



    <div className="page-container" style={{backgroundColor:"#F9FBFD"}}>
        {/* Content Wrapper START */}
        <div className="main-content">
          
        <div className='card' style={{padding:"20px"}} >
<h2>Inquirers </h2>
<div className='row'>
{/* new 101 */}

{/* end 101 */}
<div className='col-3'>
<div class="form-group">
<label for="formGroupExampleInput">Date Start</label>
<input type="date"  value={d1} onChange={(v)=>{ setD1(v.target.value)}} class="form-control" id="formGroupExampleInput" placeholder="Date"/>
</div>
</div>

<div className='col-3'>
<div class="form-group">
<label for="formGroupExampleInput">Date End</label>
<input type="date"  value={d2} onChange={(v)=>{ setD2(v.target.value)}} class="form-control" id="formGroupExampleInput" placeholder="Date"/>
</div>
</div>

<div className='row'>
<div className='col-3'>
<button onClick={()=>{

if(d1===null)
{
alert("Select Date")
}else if(d2===null)
{
alert("End Date")
}else{

  if(user=="")
  {

  }else{
    setList([])
    setSelected_website()
    setSelected()
    getInq()
    const access=JSON.parse(localStorage.getItem("Access"))
    if(access[0].a8!=true){
     window.location.replace("/admin_main")
    }
  }

}
}}  className="btn btn-primary m-r-5">Get</button>

</div>

</div>

</div>

</div>
        <h2 style={{color:"#054089"}}>Total Inquires : {list.length}</h2>
        <p>
          {f1!=""?<>{f1} / </>:<></>}
          {f2!=""?<>{f2} / </>:<></>}
          {f3!=""?<>{f3} / </>:<></>}
          {f4!=""?<>{f4} / </>:<></>}
        
        </p>
{
  listoldStatus?        <button style={{margin:"10px"}} onClick={()=>{
    resetAll()
  }}  class="btn btn-success m-r-5">Reset</button>:""
}

         <div className="row">
          
{/* s101 */}
<div className="row" style={{ margin: '0 -1px' }}>
  {/* 1  start*/}
        <div
       
         
          className="col-lg-3
 col-md-4 col-sm-6"
          style={{ padding: '3px' }}>
          <div
            className="card"
            style={{
              border: '3px solid #ddd',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              padding: '8px',
              textAlign: 'center',
              backgroundColor: 'white',
            }}
            onClick={()=>{
              getfilter_dail()
            }}

            
          >
            <div className="card-body"
              style={{ padding: '5px' }}>
              <div
                className="d-flex justify-content-between align-items-center"
              >
                <div>
                  <p
                    className="m-b-0"
                    style={{
                      marginBottom: '3px',
                      color: '#202020',
                    }}
                  >Manager Redialed</p>
                  <h4
                    style={{
                      fontSize: '1.5rem',
                      color: '#029E9D',
                    }}
                  >
                    <span>{list.length-getresponseCount()}</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* 1  end*/}

                {/* 2  start*/}
                <div
       
         
       className="col-lg-3
col-md-4 col-sm-6"
       style={{ padding: '3px' }}>
       <div
         className="card"
         style={{
           border: '3px solid #ddd',
           borderRadius: '8px',
           boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
           padding: '8px',
           textAlign: 'center',
           backgroundColor: 'white',
         }}

         onClick={()=>{
            getfilter_none_dial()
          }}

         
       >
         <div className="card-body"
           style={{ padding: '5px' }}>
           <div
             className="d-flex justify-content-between align-items-center"
           >
             <div>
               <p
                 className="m-b-0"
                 style={{
                   marginBottom: '3px',
                   color: '#202020',
                 }}
               >Manager Pending Redial</p>
               <h4
                 style={{
                   fontSize: '1.5rem',
                   color: '#029E9D',
                 }}
               >
                 <span>{getresponseCount()}</span>
               </h4>
             </div>
           </div>
         </div>
       </div>
     </div>
     {/* 2  end*/}


                     {/* 3  start*/}
                     <div
       
         
       className="col-lg-3
col-md-4 col-sm-6"
       style={{ padding: '3px' }}>
       <div
         className="card"
         style={{
           border: '3px solid #ddd',
           borderRadius: '8px',
           boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
           padding: '8px',
           textAlign: 'center',
           backgroundColor: 'white',
         }}
         onClick={(()=>(
          getfilter_type("Admin")
         ))}

         
       >
         <div className="card-body"
           style={{ padding: '5px' }}>
           <div className="d-flex justify-content-between align-items-center">
             <div>
               <p
                 className="m-b-0"
                 style={{
                   marginBottom: '3px',
                   color: '#202020',
                 }}>Inquire Send by Admin</p>
               <h4
                 style={{
                   fontSize: '1.5rem',
                   color: '#029E9D',
                 }}
               >
                 <span>{getTypeCount("Admin")}</span>
               </h4>
             </div>
           </div>
         </div>
       </div>
     </div>
     {/* 3  end*/}


                     {/* 4  start*/}
                     <div
       
         
       className="col-lg-3
col-md-4 col-sm-6"
       style={{ padding: '3px' }}>
       <div
         className="card"
         style={{
           border: '3px solid #ddd',
           borderRadius: '8px',
           boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
           padding: '8px',
           textAlign: 'center',
           backgroundColor: 'white',
         }}

         onClick={(()=>(
          getfilter_type("Manager")
         ))}

         
       >
         <div className="card-body"
           style={{ padding: '5px' }}>
           <div
             className="d-flex justify-content-between align-items-center"
           >
             <div>
               <p
                 className="m-b-0"
                 style={{
                   marginBottom: '3px',
                   color: '#202020',
                 }}>Inquire Send by Manager</p>
               <h4
                 style={{
                   fontSize: '1.5rem',
                   color: '#029E9D',
                 }}
               >
                 <span>{getTypeCount("Manager")}</span>
               </h4>
             </div>
           </div>
         </div>
       </div>
     </div>
     {/* 4  end*/}


  {status_list.map(
    (v, i) =>
      i > 0 && (
        <div
       
          key={i}
          className="col-lg-3
 col-md-4 col-sm-6"
          style={{ padding: '3px' }}>
          <div
            className="card"
            style={{
              border: '3px solid #ddd',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
              padding: '8px',
              textAlign: 'center',
              backgroundColor: 'white',
            }}

            onClick={()=>(
              getfilter(v.value)
            )}
          >
            <div className="card-body"
              style={{ padding: '5px' }}>
              <div
                className="d-flex justify-content-between align-items-center"
              >
                <div>
                  <p
                    className="m-b-0"
                    style={{
                      marginBottom: '3px',
                      color: '#202020',
                    }}
                  >
                    {v.name}
                  </p>
                  <h4
                    style={{
                      fontSize: '1.5rem',
                      color: '#029E9D',
                    }}
                  >
                    <span>{getStatusCount(v.value)}</span>
                  </h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
  )}
</div>
{/* e101 */}
         

          </div>
        

    <div className="card">
   <div style={{paddingTop:"10px",paddingLeft:"20px"}}>
   <div className='row'>
    
    <div className='col-3'>
<h6>By Type</h6>
</div>
    <div className='col-3'>
<h6>By Agent</h6>
     
      </div>
    <div className='col-3'>
<h6>By Web</h6>
     
      </div>
    <div className='col-3'>
<h6>By Team</h6>
     
      </div>
      
      </div>


   <div className='row'>

    <div className='col-3'>
    <Autocomplete
      disablePortal
      id="size-small-standard"
        size="small"
       value={selected_type}
        onChange={(event, newValue) => {
            console.log(newValue)
            setSelected_type(newValue)  
            if(newValue===null)
            {
              resetAll()
              
            }else{
              getfilter_Type_source(newValue.name)
              

            }

        }}
      options={TypeList}
      // sx={{ width: 100 }}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => (
        <Box component="li"  {...props}>
          
          {option.name}
        </Box>
      )}
      renderInput={(params) => <TextField {...params}  label="Type.." />}
    />
       
    </div>
    <div className='col-3'>
    <Autocomplete
      disablePortal
      id="size-small-standard"
        size="small"
       value={selected}
        onChange={(event, newValue) => {
            console.log(newValue)
            setSelected(newValue)  
            if(newValue===null)
            {
              resetAll()
              
            }else{
              getfilter_Agent(newValue.id,newValue.name)
              

            }

        }}
      options={agentList}
      // sx={{ width: 100 }}
      getOptionLabel={(option) => option.name}
      renderOption={(props, option) => (
        <Box component="li"  {...props}>
          
          {option.name} 
        </Box>
      )}
      renderInput={(params) => <TextField {...params}  label="Agent Name" />}
    />
    </div>
    <div className='col-3'>
    <Autocomplete
      disablePortal
      id="size-small-standard"
        size="small"
       value={selected_website}
        onChange={(event, newValue) => {
            console.log(newValue)
            setSelected_website(newValue)
            if(newValue===null)
            {
              resetAll()
              
            }else{
              getfilter_website(newValue.web)
              //getfilter_Agent

            }
            
        }}
      options={WebsiteList}
      // sx={{ width: 100 }}
      getOptionLabel={(option) => option.web}
      renderOption={(props, option) => (
        <Box component="li"  {...props}>
          
          {option.web}
        </Box>
      )}
      renderInput={(params) => <TextField {...params}  label="web" />}
    />
    </div>
    <div className='col-2' >
<Autocomplete
  disablePortal
  id="size-small-standard"
    size="small"
   value={selected_t}
    onChange={(event, newValue) => {
        console.log(newValue)
        setSelected_t(newValue)  
        if(newValue===null)
        {
          resetAll()
        }else{
          getfilter_Team(newValue.id)
          

        }

        

    }}
  options={teamList}
  // sx={{ width: 100 }}
  getOptionLabel={(option) => option.name}
  renderOption={(props, option) => (
    <Box component="li"  {...props}>
      
      {option.name}
    </Box>
  )}
  renderInput={(params) => <TextField {...params}  label="Select Team" />}
/>
</div>
   

   </div>
   
   
   </div>
   <div className="card-body">
 <div>
      <div id="data-table_wrapper" className="dataTables_wrapper ">
      
        <div className="row">
          <div className="col-sm-12">
            {
              section_b&&<>
               <table
              id="data-table"
              className="table dataTable"
              role="grid"
              aria-describedby="data-table_info"
            >
              <thead>
              <tr role="row">
                  <th
                    className="sorting_asc">
                    ID
                  </th>
                  <th
                    className="sorting_asc">
                    Website
                  </th>
               
                  <th
                    className="sorting">
                    Phone
                  </th>
                  <th className="sorting">
                    Agent Name
                  </th>
                  <th
                    className="sorting">
                    Resp.
                  </th>
                  
                  <th
                    className="sorting">
                    Status
                  </th>
                 
                  <th
                    className="sorting">
                   Action
                  </th>
                </tr>
              </thead>
              <tbody>
      {
        list.map((v,i)=>(   
        

              <>
                <tr role="row" className="odd">
              
                  <td>{v.id} </td>
                  <td style={{color:v.manager_response==0?"red":"green"}}>{v.web}</td>
                  
                  <td>{v.phone} </td>
                  
                  
                  
                  <td>{v.agent_name}</td>
           
                  
                 
              
                
                  <td>
                  <HtmlTooltip
                  sx={{borderRadius: 2,  minWidth: 300,}}
        title={
          <div >

<center>


           
<div className='row'>
 <div className='col-4'>IP</div>
 <div className='col-8' style={{color:"red",fontWeight: 'bold'}} ><b>{v.ip}</b></div>
</div>
{/* <div className='row'>
 <div className='col-12'>Ad/ch/In</div>
 <div className='col-12' style={{color:"red",fontWeight: 'bold'}} >{v.adult==""?<></>:<b style={{color:"green"}}>{v.adult}</b>}{v.child==""?<></>:<b style={{color:"red"}}> {v.child}</b>}{v.infant==""?<></>:<b style={{color:"blue"}}> {v.infant}</b>}</div>
</div> */}
<div className='row'>
 <div className='col-4'>Name</div>
 <div className='col-8' style={{color:"red",fontWeight: 'bold'}} ><b>{v.name}</b></div>
</div>

{/* <div className='row'>
 <div className='col-4'>Dep</div>
 <div className='col-8' style={{color:"red",fontWeight: 'bold'}} ><b>{v.dep}</b></div>
</div> */}
{/* <div className='row'>
 <div className='col-4'>Arri</div>
 <div className='col-8' style={{color:"red",fontWeight: 'bold'}} ><b>{v.arri}</b></div>
</div> */}
<div className='row'>
 <div className='col-4'>Qual</div>
 <div className='col-8' style={{color:"red",fontWeight: 'bold'}} ><b>{v.date}</b></div>
</div>
<div className='row'>
 <div className='col-4'>Course</div>
 <div className='col-8' style={{color:"red",fontWeight: 'bold'}} ><b>{v.makkah}</b></div>
</div>
<div className='row'>
 <div className='col-4'>Country</div>
 <div className='col-8' style={{color:"red",fontWeight: 'bold'}} ><b>{v.madina}</b></div>
</div>
<div className='row'>
 <div className='col-4'>Type</div>
 <div className='col-8' style={{color:"red",fontWeight: 'bold'}} ><b>{v.type}</b></div>
</div>

{/* <div className='row'>
 <div className='col-4'>Acc</div>
 <div className='col-8' style={{color:"red",fontWeight: 'bold'}} ><b>{v.acc}</b></div>
</div> */}
<div className='row'>
 <div className='col-4'>Date</div>
 <div className='col-8' style={{color:"red",fontWeight: 'bold'}} ><b>{v.date_portal}</b></div>
</div>
<div className='row'>
 <div className='col-4'>Time</div>
 <div className='col-8' style={{color:"red",fontWeight: 'bold'}} ><b>{v.date_time}</b></div>
</div>
 <div className='row'>
 <div className='col-12' style={{color:"red",fontWeight: 'bold'}}><a target="_blank" href={v.url}>{v.url}</a></div>
</div>
     
</center>

         
          </div>
        }
      >
        <Button style={{fontSize:"20px"}}>{v.response_num}</Button>
      </HtmlTooltip>
      </td>
      <td>{getNamesByValue(status_list,v.agent_status)}</td>
      
      <td>
      <a target='__blank' href={"view_inquiry_admin?id="+v.id}> <button  className="btn btn-warning m-r-5">{v.type}</button></a>
      </td>
    
   
   
                </tr>
           
               
              </>
           

      ))
      }
        </tbody>
        </table>
        </>
            }
           
          </div>
        </div>
        
      </div>
    </div>
  
  </div>
      <div >


     
        
        
      </div>
      
    
    </div>





        </div>
        {/* Content Wrapper END */}
        {/* Footer START */}
<Footer />
        {/* Footer END */}
      </div>
      
  </>
  );
}